<template>
  <el-dialog :title="title" width="450px" :visible.sync="dialogVisible" append-to-body :fullscreen="device==='mobile'" @close="dialogClose">
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="avatar-container">
          <el-image :src="data.avatar" :preview-src-list="[data.avatar]" fit="cover" />
        </div>
      </el-col>
      <el-col :span="24">
        <el-descriptions :label-style="{fontWeight:600}" :column="1" :colon="false" size="medium" border>
          <el-descriptions-item label="ID">{{ data.id }}</el-descriptions-item>
          <el-descriptions-item label="昵称">{{ data.nickName }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ data.mobile }}</el-descriptions-item>
          <el-descriptions-item label="分享码">{{ data.shareCode }}</el-descriptions-item>
          <slot />
        </el-descriptions>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取　消</el-button>
      <el-button type="primary" @click="handleSubmit">确　定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MemberInfo',
  props: {
    show: Boolean,
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  computed: mapGetters(['device']),
  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.dialogVisible = value
      }
    }
  },
  methods: {
    dialogClose() {
      this.$emit('close')
    },
    handleSubmit() {
      this.$emit('submit', this.data)
    }
  }
}
</script>

<style lang="scss" scoped>
  .avatar-container {
    display: block;
    text-align: center;
    margin-bottom: 20px;
    .el-image {
      width: 132px;
      height: 132px;
      border-radius: 50%;
    }
  }
</style>
